import "core-js/modules/es.array.join";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { getMapKey } from '@/lib/utils';
var m = {
  namespaced: true,
  state: {
    styleList: {},
    card: {}
  },
  mutations: {
    setStyleList: function setStyleList(state, _a) {
      var key = _a.key,
          result = _a.result;
      Vue.set(state.styleList, key, result);
    },
    setCard: function setCard(state, _a) {
      var key = _a.key,
          url = _a.url;
      Vue.set(state.card, key, url);
    }
  },
  actions: {
    /**
     * 获取样式列表
     */
    getStyleList: function getStyleList(context, _a) {
      var activityId = _a.activityId,
          type = _a.type;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite_card/style_list', {
                params: {
                  id: activityId,
                  type: type
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setStyleList', {
                  key: [activityId, type].join('_'),
                  result: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请卡。有缓存
     */
    getCard: function getCard(context, data) {
      return __awaiter(this, void 0, void 0, function () {
        var key, card, promise, response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              key = getMapKey(data);
              card = context.state.card[key];

              if (card) {
                return [2
                /*return*/
                , card];
              }

              promise = Vue.axios.get('/api/v1/invite_card/card', {
                params: {
                  id: data.activityId,
                  style: data.styleId,
                  team_id: data.teamId
                }
              });
              context.commit('setCard', {
                key: key,
                url: promise
              });
              return [4
              /*yield*/
              , promise];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCard', {
                  key: key,
                  url: rdata.data
                });
              } else {
                context.commit('setCard', {
                  key: key,
                  url: undefined
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;